import React, { useState, useEffect, useRef, useContext } from "react";
import "./Tabs.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Tabs = () => {
  const { currentLang, language } = useContext(LanguageContext);

  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [loading, setLoading] = useState(true);
  const tabsRef = useRef(null);

  const resolveUrl = (path) => {
    if (!path) return "";
    return path.startsWith("http") ? path : `${API_BASE}${path}`;
  };

  useEffect(() => {
    const fetchTabs = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/TabsSection?lang=${currentLang}`
        );

        const processedTabs = res.data.tabs.map((tab) => ({
          ...tab,
          image: resolveUrl(tab.imageUrl),
        }));

        setTabs(processedTabs);

        if (processedTabs.length > 0) {
          setActiveTab(processedTabs[0]);
        }
      } catch (err) {
        console.error("Error fetching tabs section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTabs();
  }, [currentLang]);

  if (loading) return <div className="tabs-loading">Loading...</div>;
  if (!tabs.length) return <div className="tabs-error">No tabs data found.</div>;

  const scrollTabs = (direction) => {
    if (!tabsRef.current) return;
    const scrollAmount = 250;
    tabsRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const handleSelectChange = (e) => {
    const selectedTab = tabs.find((tab) => tab.id === parseInt(e.target.value));
    setActiveTab(selectedTab);
  };

  return (
    <section className="tabs-section" dir={language === "ar" ? "rtl" : "ltr"}>
      {/* ===== Desktop Tabs Row ===== */}
      <div className="tabs-buttons-wrapper desktop-tabs">
        <button className="scroll-btn left" onClick={() => scrollTabs("left")}>
          <FaChevronLeft />
        </button>

        <div className="tabs-buttons" ref={tabsRef}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab?.id === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.title}
            </button>
          ))}
        </div>

        <button className="scroll-btn right" onClick={() => scrollTabs("right")}>
          <FaChevronRight />
        </button>
      </div>

      {/* ===== Mobile Dropdown ===== */}
      <div className="mobile-dropdown">
        <select
          value={activeTab?.id || ""}
          onChange={handleSelectChange}
          className="tabs-select"
        >
          {tabs.map((tab) => (
            <option key={tab.id} value={tab.id}>
              {tab.title}
            </option>
          ))}
        </select>
      </div>

      {/* ===== Selected Tab Content ===== */}
      {activeTab && (
        <div className="tabs-content">
          <img
            src={activeTab.image}
            alt={activeTab.title}
            onError={(e) => (e.target.src = "/fallback.jpg")}
          />
          <div
            className="tabs-description"
            style={{ textAlign: language === "ar" ? "right" : "left" }}
          >
            <h2>{activeTab.title}</h2>
            <p>{activeTab.description}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Tabs;
